import { createSlice } from "@reduxjs/toolkit";
import { logIn, signUp, verifyOTP, loadUser, logOut, updateProfile} from "./UserAction";

//for creating new Order
const userSlice = createSlice({
  name: "User",
  initialState: {
    loading: false,
    error: false,
    success: false,
    message: "",
    verifyOTPLoading: false,
    verifyOTPError: false,
    user: {},
    verifyOTPMessage: "",
    verifyOTPSuccess: false,
    isAuthenticated: false,
    loadUserLoading: true,
    loadUserError: false,
    loadUserSuccess: false,
    loadUserMessage: "",
    updateUserLoading: true,
    updateUserError: false,
    updateUserSuccess: false,
    updateUserMessage: "",
  },
  reducers: {
    clearError: (state) => {
      state.error = false;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    clearVerifyOTPError: (state) => {
      state.verifyOTPError = false;
    },
    clearVerifyOTPSuccess: (state) => {
      state.verifyOTPSuccess = false;
    },
    clearLoadUserError: (state) => {
      state.loadUserError = false;
    },
    clearLoadUserSuccess: (state) => {
      state.loadUserSuccess = false;
    },
    clearLoadUserMessage: (state) => {
      state.loadUserMessage = "";
    },
    clearVerifyOTPMessage: (state) => {
      state.verifyOTPMessage = "";
    },
    clearUpdateUserError: (state) => {
      state.updateUserError = false;
    },
    clearUpdateUserSuccess: (state) => {
      state.updateUserSuccess = false;
    },
    clearUpdateUserMessage: (state) => {
      state.updateUserMessage = "";
    },
    clearVerifyOTPLoading: (state) => {
      state.verifyOTPLoading = false;
    },
    clearUpdateUserLoading: (state) => {
      state.updateUserLoading = false;
    },
    clearLoadUserLoading: (state) => {
      state.loadUserLoading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(logIn.fulfilled, (state, action) => {
        state.message = action?.payload?.message;
        state.loading = false;
        state.error = false;
        state.success = true;
      })
      .addCase(logIn.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action?.payload;
        state.success = false;
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.message = action?.payload?.message;
        state.loading = false;
        state.error = false;
        state.success = true;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action?.payload;
        state.success = false;
      })
      .addCase(verifyOTP.pending, (state) => {
        state.verifyOTPLoading = true;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.user = action?.payload?.user;
        state.verifyOTPMessage = action?.payload?.message;
        state.isAuthenticated = true;
        state.verifyOTPLoading = false;
        state.verifyOTPError = false;
        state.verifyOTPSuccess = true;
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.verifyOTPMessage = action?.payload;
        state.verifyOTPLoading = false;
        state.verifyOTPError = true;
        state.verifyOTPSuccess = false;
      })
      .addCase(loadUser.pending, (state) => {
        state.loadUserLoading = true;
      })
      .addCase(loadUser.fulfilled, (state, action) => {
        state.user = action?.payload?.user;
        state.loadUserMessage = action?.payload?.message;
        state.isAuthenticated = true;
        state.loadUserLoading = false;
        state.loadUserError = false;
      })
      .addCase(loadUser.rejected, (state, action) => {
        state.loadUserMessage = action?.payload;
        state.loadUserLoading = false;
        state.loadUserError = true;
        state.loadUserSuccess = false;
      })
      .addCase(updateProfile.pending, (state) => {
        state.updateUserLoading = true;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.user = action?.payload?.user;
        state.updateUserMessage = action?.payload?.message;
        state.updateUserLoading = false;
        state.updateUserError = false;
        state.updateUserSuccess = true;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.updateUserMessage = action?.payload;
        state.updateUserLoading = false;
        state.updateUserError = true;
        state.updateUserSuccess = false;
      })
      .addCase(logOut.pending, (state) => {
        state.loadUserLoading = true;
      })
      .addCase(logOut.fulfilled, (state, action) => {
        state.user = {};
        state.isAuthenticated = false;
        state.loadUserLoading = false;
      })
      .addCase(logOut.rejected, (state, action) => {
        state.loadUserLoading = false;
      });
  },
});

const userAction = userSlice.actions;

export { userAction, userSlice };
